import React, { useCallback, useEffect, useState } from 'react'
import StringUtil from 'utils/string-util'
import ContractApiV2 from 'api/v2/admins/contracts-api-v2'
import { InputField } from 'components'
import PropTypes from 'prop-types'

const propTypes = {
  formikBag  : PropTypes.any,
  fieldName  : PropTypes.string,
  sellerType : PropTypes.string
}

const defaultValues = {
  formikBag  : null,
  fieldName  : '',
  sellerType : ''
}

/**
 * Contract options for dropdown input field. hooked up to Formik (only to be used within a Formik component)
 * @param {any} formikBag an object containing a subset of the injected props and methods and any props that were passed to the wrapped component.
 * @param {string} fieldName name for fieldName input-field
 */
const ExclusiveSellerContractField = ({
  formikBag,
  fieldName,
  sellerType
}) => {
  const [ contracts, setContracts ]   = useState([])
  const [ totalCount, setTotalCount ] = useState(25)

  const getContracts = useCallback((sellerType) => {
    const filters = {
      per_page    : totalCount,
      seller_type : sellerType
    }

    ContractApiV2.get({ additionalFilters: filters })
      .then((response) => {
        setContracts(response.data.contracts)
        setTotalCount(response.data.meta.total_count)
      })
      .catch((error) => {
        alert(error)
      })
  }, [ totalCount ])

  // get Contracts data
  useEffect(() => {
    getContracts(sellerType)
  }, [ getContracts, sellerType ])

  // components to show
  const SelectFieldOptions = () => (
    <>
      <option value={ '' } label={ 'Choose Contract' }/>
      {
        contracts.map((option) => (
          <option
            key={ `select-option-contract-${option.id}` }
            value={ option.id }
            label={ StringUtil.titleCase(option.type_of) }
          />
        ))
      }
    </>
  )

  return (
    <InputField
      type='select'
      name={ fieldName }
      label='Contract'
      required={ true }
      onChange={ (e) => formikBag.handleChange(e) }
    >
      <SelectFieldOptions />
    </InputField>
  )
}

ExclusiveSellerContractField.propTypes    = propTypes
ExclusiveSellerContractField.defaultProps = defaultValues

export default ExclusiveSellerContractField
